import { render, staticRenderFns } from "./VuesticWidget.vue?vue&type=template&id=9b5e2a90"
import script from "./VuesticWidget.vue?vue&type=script&lang=js"
export * from "./VuesticWidget.vue?vue&type=script&lang=js"
import style0 from "./VuesticWidget.vue?vue&type=style&index=0&id=9b5e2a90&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pagsmile/front-end/pagsmile-dashboard/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9b5e2a90')) {
      api.createRecord('9b5e2a90', component.options)
    } else {
      api.reload('9b5e2a90', component.options)
    }
    module.hot.accept("./VuesticWidget.vue?vue&type=template&id=9b5e2a90", function () {
      api.rerender('9b5e2a90', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/vuestic-theme/vuestic-components/vuestic-widget/VuesticWidget.vue"
export default component.exports